import React, { useState } from "react";

const AgeCalculator = () => {
  const [dob, setDob] = useState("");
  const [age, setAge] = useState(null);

  const calculateAge = () => {
    const birthDate = new Date(dob);
    const today = new Date();
    const calculatedAge = today.getFullYear() - birthDate.getFullYear();
    setAge(calculatedAge);
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Student Age Calculator</h2>
      <input type="date" className="border p-2 w-1/3 mt-3 flex text-center" onChange={(e) => setDob(e.target.value)} />
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full" onClick={calculateAge}>Calculate Age</button>
      {age && <div className="mt-3 text-center text-lg">Age: <span className="font-bold text-green-600">{age} years</span></div>}
    </div>
  );
};

export default AgeCalculator;
